import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadershipMember } from '../leaderboard-home';

@Component({
  selector: 'app-leaderboard-assets',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './leaderboard-assets.html',
  styleUrl: './leaderboard-assets.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaderboardAssets {
  @Input({ required: true }) leadershipMembers: LeadershipMember[] = [];
  @Input({ required: true }) assetsPagination: {
    hasNext?: boolean;
    isLoading?: boolean;
  } = {};
  @Input({ required: true }) showLoadMore = false;
  @Output() loadMore = new EventEmitter<void>();

  emitLoadMore(): void {
    this.loadMore.emit();
  }

  subtitle(member: LeadershipMember): string {
    const org = member.organizationName?.trim();
    if (org) return `Published by ${org}`;
    return member.role?.trim() || member.title?.trim() || '';
  }
}
